import React from 'react'
import { connect } from 'react-redux'
import {
  Form,
  Input,
  Select,
  Card,
  Table,
  Button,
  Row,
  Col,
  Radio,
  Space,
  Tooltip,
  Badge,
  Tag,
  Typography,
  ConfigProvider
} from 'antd'
import { CopyOutlined, createFromIconfontCN } from '@ant-design/icons';

import en from 'antd/es/locale/en_US';
import sc from 'antd/es/locale/zh_CN';
import tc from 'antd/es/locale/zh_HK';
const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_8d5l8fzk5b87iudi.js',
});
const { Paragraph } = Typography;
const APISearchResult = ({ t, size, data, dataApi, columns, handleTableChange, pagination, settingPaginationTotal, handleChangeLang }) => {
  let ChangeLang = en
  switch (handleChangeLang) {
    case "en":
      ChangeLang = en
      break;
    case "tc":
      ChangeLang = tc
      break;
    case "sc":
      ChangeLang = sc
      break;
    default:
      ChangeLang = en
      break;
  }
  console.log("handleChangeLang", handleChangeLang)
  return (
    <div>
      <h2 style={{ fontSize: 14 }}>{t('API_QUERY_STRING')}:</h2>
      <Row gutter={[0, 8]} style={{ marginBottom: '15px' }}>
        <Col span={24}>
          <label title='XML'>XML</label>
          {/* {
            text: string,
            onCopy: function,
            icon: ReactNode,
            tooltips: false | [ReactNode, ReactNode],
          } */}
          {/* <Paragraph style={{ height: '34px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} copyable={data.length === 0 ? false : { tooltips: [<label>{t('COPY')}</label>, <label>{t('COPIED')}</label>] }} className="urlInput"  onClick={(e) => { console.log(e) }}>{dataApi.base + dataApi.xml}</Paragraph> */}
          <Paragraph style={{ height: '34px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} copyable={data.length === 0 ? false : { tooltips: [t('COPY'), t('COPIED')], icon:<img src='/images/copy.svg' style={{width: '18px', marginTop:'-5px'}}/>}} className="urlInput"  onClick={(e) => { console.log(e) }}>{dataApi.base + dataApi.xml}</Paragraph>
          {/* <Input disabled value={dataApi.base+dataApi.json} addonAfter={<CopyOutlined />}/> */}
        </Col>
        <Col span={24}>
          <label title='Json'>Json</label>
          <Paragraph style={{ height: '34px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} copyable={data.length === 0 ? false : { tooltips: [t('COPY'), t('COPIED')], icon:<img src='/images/copy.svg' style={{width: '18px', marginTop:'-5px'}}/> }} className="urlInput">{dataApi.base + dataApi.json}</Paragraph>
          {/* <Input disabled value={dataApi.base+dataApi.json} addonAfter={<CopyOutlined />}/> */}
        </Col>
        <Col span={24}>
          <label title='CSV'>CSV</label>
          <Paragraph style={{ height: '34px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} copyable={data.length === 0 ? false : { tooltips: [t('COPY'), t('COPIED')], icon:<img src='/images/copy.svg' style={{width: '18px', marginTop:'-5px'}}/> }} className="urlInput">{dataApi.base + dataApi.csv}</Paragraph>
          {/* <Input disabled value={dataApi.base+dataApi.csv} addonAfter={<CopyOutlined />}/> */}
        </Col>
      </Row>
      <h2 style={{ fontSize: 14 }}>{t('API_QUERY_RESULT')}:</h2>
      <ConfigProvider locale={ChangeLang}>
        <Table
          className='searchResultTable'
          onChange={handleTableChange}
          style={{ marginTop: '15px' }}
          size={size}
          dataSource={data}
          columns={columns}
          // Use rowKey to set uniqueKey, to Prevent react error
          rowKey="Brn"
          bordered={true}
          pagination={{
            simple: false,
            // showTitle: false,
            showTotal: (total, range) =>
              // `${range[0]}-${range[1]} ${t('OF')} ${total} ${t('ITEMS')}`,
              `${t('TOTAL_ITEMS', { start: range[0], end: range[1], total: total, })}`,
            ...pagination,
            // total: settingPaginationTotal, // setting page value
            showSizeChanger: true,
            pageSizeOptions: [10, 25, 50, 100],
            // pageSize: 15,
          }}
        // scroll={{ y: 'calc(100vh - 62vh)' }}
        />
      </ConfigProvider>
      {data.length > 0 && <Row align='middle' justify='end'>
        <Col>
          <Space wrap>
            <Tooltip placement='bottom' title={t('EXPORT_CSV')}>
              <Button type='primary' className='btn-dark' href={`${dataApi.base}file/${dataApi.csv}`}>
                {t('EXPORT_CSV')}
              </Button>
            </Tooltip>
            <Tooltip placement='bottom' title={t('EXPORT_JSON')}>
              <Button type='primary' className='btn-dark' href={`${dataApi.base}file/${dataApi.json}`}>
                {t('EXPORT_JSON')}
              </Button>
            </Tooltip>
            <Tooltip placement='bottom' title={t('EXPORT_XML')}>
              <Button type='primary' className='btn-dark' href={`${dataApi.base}file/${dataApi.xml}`}>
                {t('EXPORT_XML')}
              </Button>
            </Tooltip>
          </Space>
        </Col>
      </Row>}
    </div>
  )
}

export default APISearchResult



// WEBPACK FOOTER //
// src/components/SearchResult/APISearchResult.js